import React, { createContext, useContext, useState } from 'react';

interface SketchPropertiesState {
  // LayerSettingsTab states
  id: number | null;
  uniqueSketchName: string;
  icon?: string;
  iconSize: number;
  iconRotation: number;
  fill: string;
  fillOpacity: number;
  outline: string;
  outlineOpacity: number;
  outlineWeight: number;
  strokeWidth: number;
  stroke: string;
  lineOpacity: number;
  lineFill: boolean;
  polygonOutline: boolean;
  fontStyle?: string;
  fontSize: number;
  textColour: string;
  halo: boolean;
  haloColour: string;
  haloStrength: number;
  haloRadius: number;
  lineWeight?: number;
  lineColour?: string;

  setState: React.Dispatch<React.SetStateAction<SketchPropertiesState>>;
  resetState?: (newState?: Partial<SketchPropertiesState>) => void;
}

const defaultSketchPropertiesState: SketchPropertiesState = {
  id: null,
  uniqueSketchName: '',
  icon: undefined,
  iconSize: 100,
  iconRotation: 0,
  fill: '#AAAAAA',
  fillOpacity: 100,
  outline: '#000000',
  outlineOpacity: 100,
  outlineWeight: 1,
  strokeWidth: 1,
  stroke: '#AAAAAA',
  lineOpacity: 100,
  lineFill: false,
  polygonOutline: true,
  fontStyle: undefined,
  fontSize: 12,
  textColour: '#000000',
  halo: false,
  haloColour: '#AAAAAA',
  haloStrength: 0,
  haloRadius: 0,

  setState: () => {},
};

const SketchPropertiesContext = createContext<SketchPropertiesState>(defaultSketchPropertiesState);

export const useSketchProperitesContext = () => {
  const context = useContext<SketchPropertiesState>(SketchPropertiesContext);

  if (context === undefined) {
    throw new Error('useSketchProperitesContext must be used within a LegendContextProvider');
  }
  return context;
};

export const SketchPropertiesProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, setState] = useState<SketchPropertiesState>(defaultSketchPropertiesState);

  const resetState = (newState?: Partial<SketchPropertiesState>) => {
    setState({
      ...defaultSketchPropertiesState,
      ...newState,
    });
  };
  return <SketchPropertiesContext.Provider value={{ ...state, setState, resetState }}>{children}</SketchPropertiesContext.Provider>;
};
